
import React, { useState, useEffect } from 'react';
import './App.css';
import Home from './components/Home.js';
import List from './components/List.js';
import Vitamins from './components/Vitamins.js';
import nutrients from './nutrients';
// import {useParams} from 'react-router-dom'
import { BrowserRouter as Router, Route, Switch, useParams } from 'react-router-dom';
import SingleVitamin from './components/SingleVitamin';
import ItemDetail from './components/ItemDetail.js'


function App() {

  const [list, setList] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [foodNutrients, setFoodNutrients] = useState(nutrients);
  // const [visibility, setVisibility]= useState(false)
  // const [query, setQuery]= useState('');




  useEffect(() => {
    const abortCont = new AbortController();
    setTimeout(() => {
      fetch(`https://api.spoonacular.com/recipes/findByNutrients?minZinc=10&maxZinc=100&number=2&apiKey=baa0813f65954e668aee0d31947401d3s`, { signal: abortCont.signal })
        .then(res => {

          if (!res.ok) {
console.log(res)
            throw Error("could not fetch data for that resource");

          }
          return res.json();
        })
        .then(data => {
          console.log(data);
          setList(data);
          setError(null)
          setLoading(false)
          // setQuery(q)
        })
        .catch((e) => {
          if (e.name === 'AbortError') {
            console.log('fetch aborted');
          } else {
            setLoading(false)
            setError(e.message);
            console.log(e.message)

          }
        })

    }, 4000)
    return () => abortCont.abort();
  }, []);







  return (
    <Router>

      <div >

        <Switch>
          <Route exact path='/' component={Home}>

            <Home />
          </Route>

          <Route path='/list'>
            {list && <List
              list={list}
              setList={setList}
              error={error}
              setError={setError}
              loading={loading}
              setLoading={setLoading}
            />}
            {loading && <h1 >Loading...</h1>}
            {error && <div>{error}</div>}
          </Route>
          <Route 
          exact
           path='/vitamins' >
          <h1 className='header-vitamins'>Choose a Food Nutrient</h1>

            <Vitamins 
            foodNutrients={foodNutrients} 
            // visibility={visibility} 
            // setVisibility={setVisibility}
            // query={query}/
           
            />
          </Route>
          <Route path='/vitamins/:name' component={ItemDetail}>
          </Route>
        </Switch>

      </div>
    </Router>
  );
}

export default App;
